import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  State,
  ServiceProvidersGroup,
  CooperativeServiceProviders,
} from 'models';
import groupBy from 'lodash/groupBy';
import services from 'services';

import { ServiceProvidersDetails } from 'components';

interface ServiceProvidersState {
  serviceProvidersGroups: ServiceProvidersGroup[];
  loading: boolean;
  error: boolean;
}

const ServiceProviders = () => {
  const { coopId } = useSelector((state: State) => ({
    coopId: state.settings.current_cooperative,
  }));
  const [state, setState] = useState<ServiceProvidersState>({
    serviceProvidersGroups: [],
    loading: false,
    error: false,
  });

  useEffect(() => {
    if (coopId) {
      fetchServiceProviders(coopId);
    }
  }, [coopId]);

  const fetchServiceProviders = async (coopId: string) => {
    setState((prevState) => ({ ...prevState, loading: true, error: false }));
    try {
      const serviceProvidersRes: CooperativeServiceProviders = (
        await services.get(`/api/user/cooperatives/${coopId}/serviceproviders`)
      ).data.Data;

      setState((prevState) => ({
        ...prevState,
        serviceProvidersGroups: serviceProvidersRes.Groups,
        loading: false,
      }));
    } catch (err) {
      console.error(err);
      setState((prevState) => ({ ...prevState, loading: false, error: true }));
    }
  };

  const transformedGroups = useMemo(() => {
    const { serviceProvidersGroups } = state;
    return serviceProvidersGroups.map((group) => ({
      ...group,
      ServiceProviders: groupBy(group.ServiceProviders, 'Role'),
    }));

    /* eslint-disable-next-line */
  }, [state.serviceProvidersGroups]);

  return (
    <ServiceProvidersDetails
      serviceProvidersGroups={transformedGroups}
      loading={state.loading}
      error={state.error}
    />
  );
};

export default ServiceProviders;
